import { useWebp } from '@r1-frontend/shared/hooks/useWebp';

import { REQUEST_IMAGES_PATH } from '~/src/features/request/constants';

import * as ST from './styled';


const Request = () => {
    const smartphoneImg = useWebp()
        ? `${REQUEST_IMAGES_PATH}/smartphone.webp`
        : `${REQUEST_IMAGES_PATH}/smartphone.png`;

    return (
        <ST.Wrapper>
            <ST.SWideContainer>
                <ST.Inner imgSrc={smartphoneImg}>
                    <ST.STariffSpeedSelector/>
                </ST.Inner>
            </ST.SWideContainer>
        </ST.Wrapper>
    );
};

export default Request;
